import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';
import { enableBatching } from 'redux-batched-actions';

import App from './containers/app';
import reducers from './reducers';

const createStoreWithMiddleware = applyMiddleware(reduxThunk)(createStore);

ReactDOM.render(
  <Provider store={createStoreWithMiddleware(enableBatching(reducers))}>
	<div>
	    <App/>
	 </div>
  </Provider>
  , document.querySelector('.react-container'));


// WEBPACK FOOTER //
// ./public/react/app.js